import { routes } from '@/utils/routes';

export const createBreadcrumbsPath = (onHomeClick?: (index?: number) => void) => [
  {
    label: 'Home',
    path: routes.home,
    onClick: onHomeClick
  }
];
